/**
 * Extracts a dynamic field's value by name from the row's DynamicFields JSON string/array.
 * Matches case-insensitively and ignores underscores.
 * @param {Object} row 
 * @param {string} fieldName 
 * @returns {any}
 */
export const getDynamicFieldValue = (row, fieldName) => {
  const data = row?.original ? row.original : row;
  if (!data?.DynamicFields) return null;
  try {
    const fields = typeof data.DynamicFields === "string"
      ? JSON.parse(data.DynamicFields)
      : data.DynamicFields;
    
    if (!Array.isArray(fields)) return null;

    const normalizedSearch = fieldName.toLowerCase().replace(/_/g, "");
    const field = fields.find((f) => {
      const name = (f?.FieldName || f?.fieldName || "").toLowerCase().replace(/_/g, "");
      return name === normalizedSearch;
    });

    return field ? field.FieldValue : null;
  } catch (e) {
    console.error("Failed to parse DynamicFields:", e);
    return null;
  }
};
